import { FC } from 'react';
import { Column } from 'organisms/Footer/Navigation/Column';
import styles from './styles.module.css';

export const DesktopGrid: FC = () => {
  return (
    <div className={styles.desktopGrid}>
      <Column index={0} className={styles.desktopColumn} />
      <Column index={1} className={styles.desktopColumn} />
      <Column index={2} className={styles.desktopColumn} />
      <Column index={3} className={styles.desktopColumn} />
      <div className={styles.combinedColumns}>
        <Column index={4} className={styles.desktopColumn} />
        <Column index={5} className={styles.desktopColumn} />
      </div>
    </div>
  );
};
